import React from 'react';

const Profile = (props: object) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.6489 20.6246C21.5831 20.7387 21.4884 20.8334 21.3743 20.8992C21.2603 20.965 21.1309 20.9997 20.9992 20.9996H2.99923C2.86764 20.9995 2.73841 20.9647 2.6245 20.8989C2.51059 20.833 2.41602 20.7383 2.35029 20.6243C2.28455 20.5103 2.24997 20.381 2.25 20.2494C2.25003 20.1178 2.28469 19.9886 2.35048 19.8746C3.77829 17.4062 5.97861 15.6362 8.54642 14.7971C7.27626 14.041 6.28943 12.8888 5.73747 11.5176C5.18551 10.1463 5.09894 8.63175 5.49105 7.20652C5.88316 5.78129 6.73228 4.52418 7.908 3.62824C9.08373 2.7323 10.521 2.24707 11.9992 2.24707C13.4774 2.24707 14.9147 2.7323 16.0905 3.62824C17.2662 4.52418 18.1153 5.78129 18.5074 7.20652C18.8995 8.63175 18.813 10.1463 18.261 11.5176C17.709 12.8888 16.7222 14.041 15.452 14.7971C18.0199 15.6362 20.2202 17.4062 21.648 19.8746C21.714 19.9886 21.7488 20.1178 21.7489 20.2495C21.7491 20.3811 21.7146 20.5105 21.6489 20.6246Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default Profile;
